export default {"src":"/_next/static/image/public/images/flags/flag_506.ee786a4de17fa00ac76cf30187c23204.svg","height":16,"width":24};